import { render, staticRenderFns } from "./ClientAttachmentUploadModal.vue?vue&type=template&id=11e50ab0"
import script from "./ClientAttachmentUploadModal.vue?vue&type=script&lang=js"
export * from "./ClientAttachmentUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_xsnsr4smgwphgcec6u2nh24t5a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports